module.exports = __webpack_public_path__ + "img/bg-image-1_1bg-image-1.d3f5839b.png";